import React from 'react';
import PropTypes from 'prop-types';
import { withFormik } from 'formik';
import Yup from 'yup';
import CountryPhoneCodeInput from '../../Global/Forms/CountryPhoneCodeInput';
import TelInput from '../../Global/Forms/TelInput';
import Button from '../../Global/Buttons/Button';
import Form from "../../Global/Forms/Form";

const ChangePhoneNumberForm = ({
  loggedInUser,
  submitting,
  // Formik props
  values,
  errors,
  touched,
  handleChange,
  setFieldValue,
}) => {
  const hasFormChanged = () => {
    if (loggedInUser) {
      const phoneNumberDetailsFormatted = {
        areaCode1: loggedInUser.area_code_1,
        telNo1: loggedInUser.tel_no_1,
      };

      const formikValuesFormatted = {
        areaCode1: values.areaCode1,
        telNo1: values.telNo1,
      };

      if (JSON.stringify(phoneNumberDetailsFormatted) === JSON.stringify(formikValuesFormatted)) {
        return false;
      }
      return true;
    }
    return false;
  };

  const handleCountryPhoneCodeChange = (e, dialCode) => {
    setFieldValue(`areaNo1`, dialCode);
    setFieldValue(`areaCode1`, e.target.value);
  };

  return (
    <Form className="m-b-5">
      <h3 className="like-h3 m-b-3">Phone number</h3>

      <fieldset className="m-b-5">
        <span className="faux-label">Phone number *</span>
        <p className="like-small color-grey">We require a phone number to allow you to recover your account if you lose access to your email</p>

        <div className="row">
          <div className="col-lg-4">
            <CountryPhoneCodeInput
              name="areaCode1"
              value={values.areaCode1}
              onChange={handleCountryPhoneCodeChange}
              error={errors.areaCode1}
              touched={touched.areaCode1}
              required
            />
          </div>

          <div className="col-lg-8">
            <TelInput
              name="telNo1"
              maxLength={50}
              value={values.telNo1}
              onChange={handleChange}
              error={errors.telNo1}
              touched={touched.telNo1}
              required
            />
          </div>
        </div>

        <div className="text-right form-group">
          <Button type="submit" loading={submitting} disabled={hasFormChanged() === false}>Change phone number</Button>
        </div>
      </fieldset>
    </Form>
  );
};

ChangePhoneNumberForm.propTypes = {
  loggedInUser: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired,
  // Formik
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

const FormikChangePhoneNumberForm = withFormik({
  enableReinitialize: true,
  mapPropsToValues({ loggedInUser }) {
    return {
      areaNo1: loggedInUser.area_no_1 || ``,
      areaCode1: loggedInUser.area_code_1 || ``,
      telNo1: loggedInUser.tel_no_1 || ``,
    };
  },
  validationSchema: Yup.object().shape({
    areaCode1: Yup.string()
      .label(`Area code`)
      .required(),
    telNo1: Yup.string()
      .label(`Phone number`)
      .required(),
  }),
  handleSubmit(values, bag) {
    bag.props.onSubmit(values);
  },
})(ChangePhoneNumberForm);

export default FormikChangePhoneNumberForm;



// WEBPACK FOOTER //
// ./library/app/components/Account/AccountDetails/ChangePhoneNumberForm.js